import React, { useMemo } from 'react';
import { differenceInDays, format } from 'date-fns';
import { intl } from '../lang/INTL';
import useWidgetStore from '../store/useWidgetStore';

export const useDisplayDates = (callback) => {
  const startDate = useWidgetStore((state) => state.calendar?.start_date);
  const endDate = useWidgetStore((state) => state.calendar?.end_date);
  const nights = useWidgetStore((state) => state.calendar?.nights);

  const startFormatted = useMemo(() => {
    return startDate ? format(startDate, 'MMM dd') : null;
  }, [startDate]);

  const endFormatted = useMemo(() => {
    if (!endDate || !startDate) {
      return null;
    }
    if (startDate?.getMonth?.() !== endDate?.getMonth?.()) {
      return format(endDate, 'MMM dd, yyyy');
    }
    return format(endDate, 'dd, yyyy');
  }, [endDate, startDate]);

  const numNights = useMemo(() => {
    return (startDate && endDate) ? differenceInDays(endDate, startDate) : null;
  }, [endDate, startDate]);

  const triggerText = useMemo(() => {
    if (!startFormatted || !endFormatted) {
      return intl.formatMessage({
        defaultMessage: 'Select Dates',
        id: 'calendar.selectDates',
      });
    }
    return intl.formatMessage({
        defaultMessage: '{start} - {end} ({nights})',
        id: 'calendar.datesWithNights',
      }, {
        start: startFormatted,
        end: endFormatted,
        nights: intl.formatMessage({
          defaultMessage: '{nights, plural, =1 {# night} other {# nights} }',
          id: 'calendar.nightCount',
        }, {
          nights: numNights,
        }),
      });
  }, [endFormatted, numNights, startFormatted]);

  return {
    hasDates: !!startDate && !!endDate,
    startDate: startFormatted,
    endDate: endFormatted,
    nights: numNights,
    triggerText,
  };
};
